import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';

const REQUEST_TYPES = 'RequestTypes';
export const SAVE = 'SAVE_REQUEST_TYPES';
export const FETCHING = 'FETCHING_REQUEST_TYPES';
export const NOT_FETCHING = 'NOT_FETCHING_REQUEST_TYPES';

const saveRequestTypesList = (list) => ({ type: SAVE, payload: list });
const fetchingRequestTypes = () => ({ type: FETCHING });
const notFetchingRequestTypes = () => ({ type: NOT_FETCHING });

export function getRequestTypesAction(reqParams) {
  return async (dispatch) => {
    dispatch(fetchingRequestTypes());
    try {
      const { data } = await communicate({
        url: REQUEST_TYPES,
        method: 'get',
        getParams: Utils.objects.objectToQueryString(reqParams)
      });
      const list = data?.Data;
      dispatch(saveRequestTypesList(list));
      return await Promise.resolve(list);
    } catch (error) {
      dispatch(notFetchingRequestTypes());
      toastrError(error);
      return await Promise.reject();
    }
  };
}
